import { render, staticRenderFns } from "./ShopSfPhotosField.vue?vue&type=template&id=f3909f5c&scoped=true"
import script from "./ShopSfPhotosField.vue?vue&type=script&lang=ts"
export * from "./ShopSfPhotosField.vue?vue&type=script&lang=ts"
import style0 from "./ShopSfPhotosField.vue?vue&type=style&index=0&id=f3909f5c&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../../../../node_modules/_vue-loader@15.11.1@vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "f3909f5c",
  null
  
)

export default component.exports